var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppstoreLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_2664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3368 0.504395H7.26478C3.69278 0.504395 0.800781 3.39639 0.800781 6.96839V26.0444C0.800781 29.6124 3.69278 32.5044 7.26478 32.5044H26.3408C29.9088 32.5044 32.8048 29.6124 32.8048 26.0404V6.96839C32.8008 3.39639 29.9088 0.504395 26.3368 0.504395Z",
    fill: "url(#paint0_linear_30_2664)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6654 7.85635L17.3134 6.73635C17.7134 6.03635 18.6054 5.80035 19.3054 6.20035C20.0054 6.60035 20.2414 7.49235 19.8414 8.19235L13.5974 19.0004H18.1134C19.5774 19.0004 20.3974 20.7204 19.7614 21.9124H6.52143C5.71343 21.9124 5.06543 21.2644 5.06543 20.4564C5.06543 19.6484 5.71343 19.0004 6.52143 19.0004H10.2334L14.9854 10.7644L13.5014 8.18835C13.1014 7.48835 13.3374 6.60435 14.0374 6.19635C14.7374 5.79635 15.6214 6.03235 16.0294 6.73235L16.6654 7.85635ZM11.0494 23.4124L9.64943 25.8404C9.24943 26.5404 8.35743 26.7764 7.65743 26.3764C6.95743 25.9764 6.72143 25.0844 7.12143 24.3844L8.16143 22.5844C9.33743 22.2204 10.2934 22.5004 11.0494 23.4124ZM23.1054 19.0084H26.8934C27.7014 19.0084 28.3494 19.6564 28.3494 20.4644C28.3494 21.2724 27.7014 21.9204 26.8934 21.9204H24.7894L26.2094 24.3844C26.6094 25.0844 26.3734 25.9684 25.6734 26.3764C24.9734 26.7764 24.0894 26.5404 23.6814 25.8404C21.2894 21.6924 19.4934 18.5884 18.3014 16.5204C17.0814 14.4164 17.9534 12.3044 18.8134 11.5884C19.7694 13.2284 21.1974 15.7044 23.1054 19.0084Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_2664",
    x1: 16.8028,
    y1: 0.504395,
    x2: 16.8028,
    y2: 32.5044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18BFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2072F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_2664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.800781 0.504395)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstoreLogo);
export default __webpack_public_path__ + "static/media/appstore-logo.ea53c5bcc3e237e8f6d7fedf6dada4ac.svg";
export { ForwardRef as ReactComponent };